var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPersonOutline = props => {
  const {
    size,
    color,
    svgProps
  } = props;
  props = {
    width: size || 24,
    height: size || 24,
    color: color || 'currentColor',
    ...svgProps
  };
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 3.333A3.333 3.333 0 1110 10a3.333 3.333 0 010-6.667zM10 5a1.667 1.667 0 100 3.333A1.667 1.667 0 0010 5zm0 5.833c2.225 0 6.667 1.109 6.667 3.334v2.5H3.333v-2.5c0-2.225 4.442-3.334 6.667-3.334zm0 1.584c-2.475 0-5.083 1.216-5.083 1.75v.916h10.166v-.916c0-.534-2.608-1.75-5.083-1.75z"
  })));
};
export default SvgPersonOutline;